import { useEffect, useState } from "react";
import { AxiosCall } from "../models/axiosModel";
import { fetchRequestAdapter } from "../adapters/fetchAdapter";
import { AxiosResponse } from "axios";
import { customDelay } from "../helpers/authHelper";
import { nextProxyBase } from "../helpers/nextApi";
import useUserCountry from "./useUserCountry";
import { useSelector } from "react-redux";
import { AppStore } from "../redux/store";

const useCallApiAndLoad = (delayMilliseconds: number = 0) => {
  const user = useSelector((store: AppStore) => store.auth);
  const { country } = useSelector((store: AppStore) => store.country);
  const [isLoading, setIsLoading] = useState(false);
  const { getServiceUrlCountry } = useUserCountry();
  let controller = new AbortController();

  // used for testing

  const callEndpoint = async (axiosCall: AxiosCall<any>, signal?: AbortSignal) => {
    setIsLoading(true);
    let result: AxiosResponse;
    let response;
    try {
      if (delayMilliseconds > 0) {
        await customDelay(delayMilliseconds); // used for testing
      }
      const urlService = getServiceUrlCountry();
      if (!urlService) {
        response = fetchRequestAdapter(
          getDefautlErrorWithMessage(
            "User does not have permission for country service",
            1
          )
        );
      } else {
        if (user?.realm === "customer" && country) {
          // Customer pasa por el proxy de Next: las cookies httpOnly viajan
          // automáticamente y el proxy inyecta el Bearer desde propi_session.
          // Mantenemos el `/c` para compatibilidad con el path del backend.
          result = await axiosCall.call(`${nextProxyBase(country)}/c`, { signal });
        } else if (user?.realm === "customer") {
          result = await axiosCall.call(`${urlService}/c`, { signal });
        } else {
          result = await axiosCall.call(urlService, { signal });
        }
        // config data headers request status statusMessage
        response = fetchRequestAdapter(result); // status, statusText, data
      }
    } catch (e: any) {
      setIsLoading(false);
      if (e.code === "ERR_NETWORK") {
        response = fetchRequestAdapter(
          getDefautlErrorWithMessage("Connection Error!")
        );
      } else {
        response = fetchRequestAdapter(e.response); // status, statusText, data
      }
    }
    setIsLoading(false);
    return response;
  };

  const getDefautlErrorWithMessage = (
    message: string = "General Error.",
    code: number = 0
  ) => {
    return {
      data: {
        code,
        message,
        data: {},
      },
      status: 0,
      statusText: message,
    };
  };

  useEffect(() => {
    // TODO test this
    return () => {
      setIsLoading(false);
      controller && controller.abort();
    };
  }, []);

  return {
    isLoading,
    callEndpoint,
  };
};

export default useCallApiAndLoad;
